import "@al/rc-lazy-image/lib/index.css";
import LazyImage from "@al/rc-lazy-image";
export default LazyImage;